import type { CleanSearchTableState } from "./actions/cleanSearchTableState";
import type { TableView } from "owa-mail-list-store";
import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "MailSearchActions" */ "./lazyIndex"), { name: "MailSearchActions" });

export const lazyLoadSearchTable: LazyAction<typeof lazyIndex.loadSearchTable, typeof lazyModule> = new LazyAction(lazyModule, m => m.loadSearchTable);

export const lazyCleanSearchTableState: (searchTableView: TableView, state?: CleanSearchTableState | undefined) => Promise<void> = new LazyAction(lazyModule, m => m.cleanSearchTableState).importAndExecute;

export const lazyLoadMoreFindItemSearch: LazyAction<typeof lazyIndex.loadMoreFindItemSearch, typeof lazyModule> = new LazyAction(lazyModule, m => m.loadMoreFindItemSearch);
export const lazyLoadMoreSubstrateSearch: LazyAction<typeof lazyIndex.loadMoreSubstrateSearch, typeof lazyModule> = new LazyAction(lazyModule, m => m.loadMoreSubstrateSearch);

export const lazyEmitCopilotAnswerCombinedLayout: LazyAction<typeof lazyIndex.emitCopilotAnswerCombinedLayout, typeof lazyModule> = new LazyAction(lazyModule, m => m.emitCopilotAnswerCombinedLayout);
